import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { Row, Col, Spinner } from "react-bootstrap";

import Cookies from "js-cookie";

import { usePlan } from "../hooks/planHook";
import { PALETTE } from "../../common/ThemeConstants";
import DetailCol from "../../common/components/DetailCol";
import { postRequest } from "../../api/axiosRequests";
import { useAuth } from "../../auth/hook";
import DetailsHeader from "../../common/components/DetailsHeader";
import PlanHeader from "../components/PlanHeader";
import { useWindowWidth } from "../../api/useWindowWidth";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { getEquipmentIcon } from "../../common/Utilities";

export default function PlanDetails() {
  const planContext = usePlan();
  const auth = useAuth();
  const [_, isMobile] = useWindowWidth();
  const [isLocked, setIsLocked] = useState(false);
  const [buttonContent, setButtonContent] = useState("Acquista");
  const paddingBottom = isLocked ? 100 : 0;

  const createSessionCheckout = (id) => {
    if (!auth.user.email || !auth.user.cf) {
      alert(
        "Completa il tuo profilo per procedere all'acquisto! Vai alle impostazioni e inserisci il Codice Fiscale."
      );
      return;
    }
    setButtonContent(
      <Spinner
        className="py-2 px-2"
        size="sm"
        color={PALETTE.SECONDARYCOLOR}
        animation="border"
      />
    );
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const promise = postRequest(
      "createPlanCheckoutSession/",
      { idPlan: id },
      headers
    );
    promise
      .then((res) => {
        window.location.href = res.data.checkoutUrl;
      })
      .catch((errs) => {
        console.log(errs);
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsLocked(planContext.planData.isLocked);
  }, [planContext.planData.isLocked]);

  return (
    <div
      style={{
        minHeight: "100vh",
      }}
    >
      {isMobile ? <DetailsHeader /> : <PlanHeader title={planContext.planData.name} showLogo />}
      {isLocked && (
        <>
          <div
            className="m-auto px-3"
            style={{
              width: "100%",
              bottom: 40,
              position: "fixed",
              zIndex: 101,
              background: PALETTE.LIGHTGRAY
            }}
          >
            <Container
              onClick={() => createSessionCheckout(planContext.planData.id)}
              className="rounded-pill shadow p-1"
              style={{
                cursor: "pointer",
                textAlign: "center",
                background: PALETTE.GRADIENT,
                zIndex: 101,
              }}
            >
              <div
                className="rounded-pill"
                style={{
                  paddingTop: 15,
                  paddingBottom: 15,
                  color: PALETTE.WHITE,
                  fontWeight: "bold",
                }}
              >
                <span>{buttonContent}</span>
              </div>
            </Container>
          </div>
        </>
      )}
      {isMobile ? (
        <div style={{ paddingBottom: paddingBottom, opacity: isLocked ? 0.7 : 1 }}>
          <Row className="m-auto text-center">
            <Col
              lg={6}
              className="m-auto px-0"
              style={{
                backgroundImage: `url(${planContext.planData.cover})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: 1,
                maxHeight: "60vh"
              }}
            />
            <Col lg={6} className="py-2">
              <Row className={`text-start ${planContext.planData.equipments.length > 0 ? "pb-0" : "pb-2"}`}>
                <Col xs={isLocked ? 8 : 12}>
                  <p className="mb-0" style={{ fontWeight: "bold", fontSize: 24 }}>{planContext.planData.name}</p>
                </Col>
                {isLocked && (
                  <Col xs={4} className="text-end">
                    <span>Prezzo: </span><span style={{ fontWeight: "bold", fontSize: 24 }}>{`${planContext.planData.price}€`}</span>
                  </Col>
                )}
              </Row>
              {planContext.planData.equipments.length > 0 && (
                <Row className="pb-2 text-start" style={{ fontSize: 26 }}>
                  <Col className="text-start">
                    {planContext.planData.equipments.length > 0 && planContext.planData.equipments.map((equipment, index) => (
                      <span
                        key={index}
                        className="rounded-md py-1 px-2 my-1 me-2 align-self-center shadow-sm"
                        style={{ fontSize: 10, color: PALETTE.GRAY, backgroundColor: PALETTE.LIGHTGRAY, display: "inline-block" }}
                      >
                        <span>{getEquipmentIcon(equipment.name)}</span>
                        <span>{`${equipment.name}`}</span>
                      </span>
                    )
                    )}
                  </Col>
                </Row>
              )}
              <Row className="text-start pb-2">
                <Col>
                  <p className="mb-0">{planContext.planData.description}</p>
                </Col>
              </Row>
              <Row className="m-auto">
                <DetailCol
                  mainText={planContext.planData.level}
                  secondaryText={"Livello"}
                  paddingRight={true}
                />
                <DetailCol
                  mainText={planContext.planData.weeks}
                  secondaryText={"Settimane"}
                  paddingLeft={true}
                />
              </Row>
            </Col>
          </Row>
        </div>
      ) : (
        <ContainerResponsive>
          <Container className="mt-2" style={{ paddingBottom: paddingBottom, opacity: isLocked ? 0.5 : 1 }}>
            <Row className="m-auto text-center">
              <Col lg={6} className="m-auto px-0">
                <img
                  src={planContext.planData.cover}
                  alt={planContext.planData.name}
                  className="rounded-md shadow"
                  style={{ maxWidth: "100%", maxHeight: "60vh" }}
                />
              </Col>
              <Col lg={6} className="py-2">
                <Row className={`text-start ${planContext.planData.equipments.length > 0 ? "pb-0" : "pb-2"}`}>
                  <Col xs={isLocked ? 8 : 12}>
                    <p className="mb-0" style={{ fontWeight: "bold", fontSize: 24 }}>{planContext.planData.name}</p>
                  </Col>
                  {isLocked && (
                    <Col xs={4} className="text-end">
                      <span>Prezzo: </span><span style={{ fontWeight: "bold", fontSize: 24 }}>{`${planContext.planData.price}€`}</span>
                    </Col>
                  )}
                </Row>
                {planContext.planData.equipments.length > 0 && (
                  <Row className="text-start pb-3" style={{ fontSize: 26 }}>
                    <Col className="text-start">
                      {planContext.planData.equipments.length > 0 && planContext.planData.equipments.map((equipment, index) => (
                        <span
                          key={index}
                          className="rounded-md py-1 px-2 my-1 me-1 align-self-center shadow-sm"
                          style={{ fontSize: 10, color: PALETTE.GRAY, backgroundColor: PALETTE.LIGHTGRAY, display: "inline-block" }}
                        >{getEquipmentIcon(equipment.name)}{`${equipment.name}`}</span>
                      )
                      )}
                    </Col>
                  </Row>
                )}
                <Row className="text-start pb-3">
                  <Col>
                    <p className="mb-0">{planContext.planData.description}</p>
                  </Col>
                </Row>
                <Row className="m-auto">
                  <DetailCol
                    mainText={planContext.planData.level}
                    secondaryText={"Livello"}
                    paddingRight={true}
                  />
                  <DetailCol
                    mainText={planContext.planData.weeks}
                    secondaryText={"Settimane"}
                    paddingLeft={true}
                  />
                </Row>
              </Col>
            </Row>
          </Container>
        </ContainerResponsive>
      )}
    </div>
  );
}
